import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

const VALUE_COLUMN_PREFIX = "value_";

const toRowFilterParams = (
  columnId: string,
  filterValue: string
): Record<string, string> | undefined => {
  const templateId = columnId.startsWith(VALUE_COLUMN_PREFIX)
    ? columnId.slice(VALUE_COLUMN_PREFIX.length)
    : "";
  return templateId
    ? { [`row_filter[${templateId}][icontains]`]: filterValue }
    : undefined;
};

const toDigits = (value: unknown) =>
  String(value ?? "")
    .trim()
    .replace(/[.,]/g, "");

const isFilled = (value: unknown) =>
  value !== undefined && value !== null && String(value).trim() !== "";

export const anchorDataOverviewEntityAdapter: EntityAdapter = {
  entity: "anchorData/overview",
  defaultSort: {
    sort: "company_name",
    tableSort: "company_name",
    descending: false,
  },
  columnFiltersParams: (filters) =>
    filters.some(
      (filter) => filter.column !== "company_name" && isFilled(filter.value)
    )
      ? { include_only_companies_with_matching_anchor_data_value: true }
      : {},
  mapPriceFilter: (filter, queryKey) => {
    const digits = toDigits(filter.value);
    if (digits === "") {
      return {};
    }
    return toRowFilterParams(filter.column, digits) ?? { [queryKey]: digits };
  },
  mapColumnFilter: (filter) =>
    filter.customFilterId === "value"
      ? toRowFilterParams(filter.column, String(filter.value))
      : undefined,
  matchesPriceFilterClientSide: (cellValue, filterValue) => {
    const filterDigits = toDigits(filterValue);
    return filterDigits === "" || toDigits(cellValue) === filterDigits;
  },
  allowsDateRangeFilters: false,
  mapExactDateFilter: (formattedDate, { customFilterId, columnId }) => {
    const rowFilterParams =
      customFilterId === "value"
        ? toRowFilterParams(columnId, formattedDate)
        : undefined;
    if (rowFilterParams) {
      return rowFilterParams;
    }
    return customFilterId
      ? { [`${customFilterId}__icontains`]: formattedDate }
      : undefined;
  },
};
